import { render } from "./SubSecondRecommendedSettings.vue?vue&type=template&id=29455ed0"
import script from "./SubSecondRecommendedSettings.vue?vue&type=script&lang=js"
export * from "./SubSecondRecommendedSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__